import { csvExportDateFormat } from "../../agent-production/helpers/dataFormatters";
import { generateFileName } from "../../common/helpers/export";
import { fieldMarkers } from "../../common/constants/export";
import { exportFilenameTemplates } from "../constants/export";

export const exportTypes = Object.freeze({
    mdSearchResults: 'mdSearchResults',
    mdOfficeBreakdown: 'mdOfficeBreakdown',
    mdListingsBreakdown: 'mdListingsBreakdown',
});

export const getOfficeBreakdownFilename = (listingType) => {
    const date = csvExportDateFormat(new Date());
    return generateFileName(exportFilenameTemplates.officeBreakdown, {
        [fieldMarkers.LISTING_TYPE]: listingType,
        [fieldMarkers.DATE]: date,
    });
};

export const getListingsBreakdownFilename = (listingType, listingStatus) => {
    const date = csvExportDateFormat(new Date());
    return generateFileName(exportFilenameTemplates.listingsBreakdown, {
        [fieldMarkers.LISTING_TYPE]: listingType,
        [fieldMarkers.DATE]: date,
        [fieldMarkers.LISTING_STATUS_FILTER]: listingStatus,
    });
};

export const getSearchResultsFileName = (listingView) => {
    const date = csvExportDateFormat(new Date());

    return generateFileName(exportFilenameTemplates.searchResults, {
        [fieldMarkers.LISTING_VIEW]: listingView,
        [fieldMarkers.DATE]: date,
    });
};

export const getFilename = exportDetails => ({
    [exportTypes.mdSearchResults]:
        getSearchResultsFileName(exportDetails.listingView),
    [exportTypes.mdOfficeBreakdown]:
        getOfficeBreakdownFilename(exportDetails.listingType),
    [exportTypes.mdListingsBreakdown]:
        getListingsBreakdownFilename(exportDetails.listingType, exportDetails.listingStatus),
});
